module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/bold_2-8860692d153ebb2753904de1448b1526.png";